module.exports = __webpack_public_path__ + "windows.d98157.svg";